import BaseCardBehavior from './BaseCardBehavior';
import CardStateHelper from '../CardStateHelper';
import { CardType } from '../../../Prototype/Level/Card/CardType';
import { CardTask } from '../CardTasks';
import { SCORE_KEY_CARD, SCORE_LOCK_CARD } from '../../../Constants/Score';
import { IGameState } from '../../Game/IGameState';
import { ICardsState } from '../ICardState';
import { CardState } from 'Prototype/Level/Card/CardState';

export default class KeyCardBehavior extends BaseCardBehavior {
    public play(state: IGameState): IGameState {
        let cardsState: ICardsState = state.levelState.cardsState;
        const currentCardState = CardStateHelper.getCardState(
            cardsState,
            this.cardID
        );

        const targets: string[] = [];

        if (currentCardState === CardState.IN_PLAY) {
            // Discard this card.
            cardsState = CardStateHelper.setCardDiscarded(
                cardsState,
                this.cardID
            );

            // Find all lock cards and discard them (even if they are obscured/facedown).
            cardsState.inPlay.forEach((cardID: string) => {
                if (cardsState.cards[cardID].type === CardType.lock) {
                    cardsState = CardStateHelper.setCardDiscarded(
                        cardsState,
                        cardID
                    );
                    targets.push(cardID);
                }
            });
        }

        // Add score.
        const scores: number[] = [
            SCORE_KEY_CARD,
            ...Array(targets.length).fill(SCORE_LOCK_CARD),
        ];
        cardsState = CardStateHelper.addTurnScore(cardsState, ...scores);

        // Trigger key unlock animation task.
        cardsState = CardStateHelper.setStateTaskData(cardsState, {
            task: CardTask.KEY,
            cards: [this.cardID, ...targets],
            cardsScore: [...scores],
        });

        // Clear undo history when a key card is played.
        cardsState = CardStateHelper.clearUndoHistory(cardsState);

        return {
            ...state,
            levelState: { ...state.levelState, cardsState },
        };
    }
}
